import {useEthers} from '@usedapp/core';
import {useMemo} from 'react';

import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import useDebouncedQuery from '~hooks/useDebouncedQuery';
import {FiltersType, FiltersWhitelistType} from '~providers/FiltersProvider';
import {filtersToQueryString} from '~utils/filters';

export default function useFetchFilteredPlotsIds(
    endpoint: ApiEndpoints,
    withWallet: boolean,
    filters: FiltersType,
    filtersWhitelist: FiltersWhitelistType,
) {
    const {account} = useEthers();

    const {apiGet} = useFetch();

    const queryString = filtersToQueryString(filters, filtersWhitelist);

    const queryParams = useMemo(
        () =>
            withWallet
                ? {
                      walletAddress: account,
                  }
                : {},
        [account],
    );

    return useDebouncedQuery(
        800,
        [endpoint, queryString, queryParams],
        ({signal}) => {
            if (filtersWhitelist.length && !queryString.length) {
                return null;
            }

            return apiGet<number[]>(`${endpoint}?${queryString}`, {
                signal,
                queryParams,
            });
        },
        {
            staleTime: 1000 * 60 * 2,
            cacheTime: 1000 * 60 * 2,
            refetchOnWindowFocus: false,
            retry: 1,
            retryDelay: 1000,
            keepPreviousData: true,
        },
    );
}
